import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import {
  MobileSectionPage,
  SectionPage,
} from '../../../hooks/routes/loadableSectionPage';
import useSectionDependantRoutes from '../../../hooks/routes/useSectionDependantRoutes';
import Section from '../../../models/Section';
import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import Paths from '../../../types/Paths';
import SectionAwareRoute from '../SectionAwareRoute';

const SectionRoute = ({ configStore, uiStore, section, overrideComponent }) => {
  const match = useRouteMatch();
  const sectionDependantRoutes = useSectionDependantRoutes({
    configStore,
    uiStore,
    section,
    match: match.path,
    overrideComponent,
  });

  return (
    <Switch>
      <Route
        key={section.id}
        exact
        path={match.path}
        children={() => {
          const sectionPageComponent = uiStore.isMobile ? (
            <MobileSectionPage section={section} />
          ) : (
            <SectionPage section={section} />
          );

          return (
            <SectionAwareRoute
              section={section}
              component={overrideComponent || sectionPageComponent}
            />
          );
        }}
      />
      {sectionDependantRoutes}
      <Route key={Paths.FrontPage} children={() => <Redirect to="/" />} />
    </Switch>
  );
};

SectionRoute.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  section: modelOf(Section).isRequired,
  overrideComponent: PropTypes.node,
};

export default inject('configStore', 'uiStore')(observer(SectionRoute));
